const BodyContent = ({ children }) => (
  <div className="flex-auto min-w-0 lg:py-[52px]">{children}</div>
);

export default BodyContent;
